import '../../style.css'
import { Search } from '../../script/Search'
import { ImgData } from '../../../../state/atom'
import { useRecoilState } from 'recoil'
import { useState } from 'react'

export const InputSearch = (x: any) => {
  const [Images, setImages] = useRecoilState(ImgData)
  const [newFile, setNewFile] = useState("")
  return (
    <div className={`InputSearch ${x.clas}`}>
      <input
        onChange={(e) => {
          setNewFile(e.target.value)
        }}
        type="text"
        name=""
        id=""
        placeholder="Search"
      />
      <button
        onClick={(e) => {
          x.funcS(newFile)
          x.funcB('hidden')
          Search(Images, x.testo)
        }}
      >
        Search
      </button>
    </div>
  )
}
